import * as React from 'react';
import Button from '@mui/joy/Button';
import { Typography, Box } from "@mui/joy";

import { useThemeContext } from '../../context/ThemeContext';
import BiddersCard from '../../blocks/customer/cardsection/BiddersCard';
import Reviews from '../Reviews';
const FundiHemoSection = () => {
    const { isSM, isMd, isMD, isLg } = useThemeContext()
    return (
        <>
            <Box
                sx={{
                    width: isSM ? '100%' : isMD ? '100%' : isMd ? '1207px' : '1207px',
                    padding: isSM ? '5px' : isMD ? '10px' : isMd ? '10px' : 0,
                    margin: '0 auto',
                    boxSizing: 'border-box',
                }}
            >

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box
                        sx={{


                            width: isSM ? '150px' : isMD ? '600%' : isMd ? '600px' : isLg ? '600px' : '600px',


                        }}
                    >

                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                mb: 2,

                                width: '100%',

                            }}
                        >



                            <Box sx={{ flex: 1 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: 4,
                                        maxWidth: '100%',

                                    }}
                                >
                                    <Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems:'center',

                                                gap: 4,
                                                maxWidth: '100%',

                                            }}
                                        >
                                            <Typography variant="h4" sx={{ fontWeight: 'bold',fontSize:'22px' }}>
                                            Alex
                                        </Typography>
                                            <Reviews />
                                        </Box>
                                        <Typography
                                            sx={{

                                                maxWidth: '100%',
                                                color: '#666666'
                                            }}
                                        >
                                            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut quisquam ducimus quis itaque aspernatur deserunt?
                                        </Typography>

                                    </Box>



                                    <Box sx={{ textAlign: 'left',width:'100%' }}>
                                        <Typography variant="h5" sx={{ fontWeight: 'bold',fontSize:'20px' }}>
                                            Location
                                        </Typography>
                                        <Typography variant="h5" sx={{ fontWeight:500 }}>
                                        City Name, Country Name
                                        </Typography>
                                    </Box>

                                </Box>

                            </Box>



                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                               justifyContent:'left',
                               alignItems:'center',
                                gap: 2,
                                mt:2

                            }}
                        >
                            <Button variant="outlined"
                                sx={{

                                    backgroundColor: "#fff",
                                    width: isSM ? '140px' : isMD ? '150px' : isMd ? '200px' : isLg ? '210px' : '210px',
                                    height: "36px",
                                    padding: isSM ? '5px' : isMD ? '10px' : isMd ? '1rem' : 0,

                                    color: "#28A745",
                                    border: "0.5px solid #28A745",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    borderRadius: "6px",
                                    lineHeight: "19.5px",
                                    "&:hover": {
                                        backgroundColor: "#ffe",
                                        color: "#28A745", boxShadow: 3,
                                    }
                                }}
                            >
                                Chat
                            </Button>
                            <Button variant="contained"
                                sx={{
                                    backgroundColor: "#28A745",
                                    width: isSM ? '140px' : isMD ? '150px' : isMd ? '200px' : isLg ? '210px' : '210px',
                                    height: "36px",
                                    padding: isSM ? '5px' : isMD ? '10px' : isMd ? '1rem' : 0,
                                    borderRadius: "6px",
                                    color: "#fff",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    lineHeight: "19.5px"
                                }}

                            >
                                Follow
                            </Button>
                        </Box>

                    </Box>
                    <Box>
                        <BiddersCard />

                    </Box>


                </Box>

                <Box mt={2}>

                    <Typography level="h2" sx={{ color: "#666666", fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '24px' : '24px', mb: 2 }}>
                        About Me
                    </Typography>

                    <Typography level="body-xs" sx={{ width: "100%", fontSize: isSM ? '14px' : isMD ? '14px' : isMd ? '16px' : '18px', fontWeight: 400, p: 3, backgroundColor: '#F4F4F4', borderRadius: '7px' }}>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium incidunt alias recusandae quidem commodi aliquid adipisci eaque quisquam sapiente? Perspiciatis perferendis tenetur placeat ad nam?
                    </Typography>
                </Box>

                <Typography level="h2" sx={{ color: "#666666", fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '24px' : '24px', mb: 2, mt: 2 }}>
                    Categories By job
                </Typography>

            </Box>
        </>
    )
}

export default FundiHemoSection;